import ChartNivBreedQrsComplexTachycardie from "../../../../src/client/niv_acuteboekje/json/breed-qrs-complex-tachycardie.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivBreedQrsComplexTachycardie,
  ChartNivSimple,
  ButtonSchematic,
  React
};